import dayjs from "dayjs";

export default {
  methods: {
    dateForHuman(date) {
      return dayjs(date).format("ddd, MMM d, YYYY h:m A");
    },
  },
};
